import {useState} from "react";
import ShowMoreText from "react-show-more-text";

export default function UsageFeeDescription({description}) {
    const [readMore, setReadMore] = useState(false);

    return (
        // use code below if we want to partially hide the usage description fees
        // <ShowMoreText className="usage-fee-description"
        //               anchorClass="show-more-less-clickable"
        //               lines={2}
        //               more="More"
        //               less=""
        //               expanded={readMore}
        //               onClick={() => setReadMore(true)}
        //               truncatedEndingComponent={"... "}>
        //     {description}
        // </ShowMoreText>
        <div className="usage-fee-description">
            {description}
        </div>
    )
}
